import { useSetAtom } from "jotai";
import { useEffect } from "react";
import { createSearchParams, useLocation } from "react-router-dom";
import { AtomWelToken } from "~src/jotai";
import { GetRidAuth } from "~src/service/welfare";

export const useGetWelfareRid = (cb: (rid:string) => void, deps?: React.DependencyList | undefined) => {
  const token = localStorage.getItem("mio-token")
  const location = useLocation()
  const setAtomWelToken = useSetAtom(AtomWelToken)
  useEffect(() => {
    if (!token) {
      const data = createSearchParams(location.search.split("?")[1] || "")
      localStorage.setItem("mio-token", data.get("token") || "")
      GetRidAuth().then((token) => {
        setAtomWelToken(token)
        cb(token)
      })
    } else {
      GetRidAuth().then((token) => {
        setAtomWelToken(token)
        cb(token)
      })
    }
  }, deps)
}